import { ResultOf, readFragment } from "gql.tada";
import { CaseStudyCardSectionById } from "@queries/entries/CaseStudyCardSectionById";
import { CaseStudyCardSectionFragment } from "@queries/fragments/CaseStudyCardSectionFragment";
import { CaseStudyCard } from "./CaseStudyCard";

export const CaseStudyCardSection = ({
  entry: { caseStudyCardSection: entry },
}: {
  entry: ResultOf<typeof CaseStudyCardSectionById>;
}) => {
  const section = entry ? readFragment(CaseStudyCardSectionFragment, entry) : null;
  const cards = section?.caseStudyCardsCollection?.items ?? [];
  if (cards.length === 0) return null;

  return (
    <section className="case-study-card-section container-base py-[150px]">
      <ul className="flex flex-wrap min-[1920px]:flex-nowrap gap-[30px] max-w-[1260px] min-[1920px]:max-w-none mx-auto justify-center">
        {cards.map(card =>
          card && (
            <li
              key={card.sys.id}
              className="dsk:w-[calc(50%-15px)] max-w-[615px] min-[1920px]:w-auto min-[1920px]:flex-1 min-[1920px]:max-w-none"
            >
              <CaseStudyCard card={card} />
            </li>
          )
        )}
      </ul>
    </section>
  );
};
